import Konva from 'konva';

export const createLayer = ({ img, container }) => {
  return new Promise((resolve, reject) => {
    const imageObj = new Image();
    imageObj.crossOrigin = 'anonymous';
    imageObj.onload = e => {
      const { naturalWidth, naturalHeight } = e.target;
      const stage = new Konva.Stage({
        container,
        width: naturalWidth,
        height: naturalHeight
      });
      const layer = new Konva.Layer();

      stage.add(layer);

      resolve({ stage, layer });
    };
    imageObj.src = img;
  });
};

export const drawImage = ({ img, x = 0, y = 0, width, height }) => {
  return new Promise((resolve, reject) => {
    const imageObj = new Image();
    imageObj.crossOrigin = 'anonymous';
    imageObj.onload = e => {
      const { naturalWidth, naturalHeight } = e.target;

      const image = new Konva.Image({
        x,
        y,
        image: imageObj,
        width: width || naturalWidth,
        height: height || naturalHeight
      });

      resolve(image);
    };
    imageObj.src = img;
  });
};

export const drawText = ({ text, x, y, color }) => {
  const textNode = new Konva.Text({
    x,
    y,
    text,
    fontSize: 60,
    width: 700, // 设置宽度以启用换行
    fill: color,
    align: 'center',
    fontFamily: 'Calibri',
    lineHeight: 1.3
  });

  const lineHeight = textNode.fontSize() * textNode.lineHeight(); // 行高
  const lineCount = textNode.height() / lineHeight;

  console.log('lineCount', textNode.height(), lineHeight);
  if (lineCount <= 1) {
    textNode.y(y + 60);
  }

  return textNode;
};

export default {
  createLayer,
  drawImage,
  drawText
};
